export default __webpack_public_path__ + "assets/images/bcc4618a681913fb150de845eba3e40f.jpg";